export const TYPE_OF_PAGE_DESTINATION = 'destination'
export const TYPE_OF_PAGE_HOLIDAY = 'holiday'
export const TYPE_OF_PAGE_BNBL = 'bnbl'
export const TYPE_OF_PAGE_CONTENT_HUB = 'pageContentHub'

export const PAGE_NAME_BNBL_LANDING = 'bnblLanding'
export const PAGE_NAME_TWC_LANDING = 'twcLanding'
export const PAGE_NAME_EWC_LANDING = 'ewcLanding'
export const PAGE_NAME_HOMES_AND_VILLAS = 'homes-and-villas'
